import { render, staticRenderFns } from "./customPagination.vue?vue&type=template&id=b7bd3d98"
import script from "./customPagination.vue?vue&type=script&lang=js"
export * from "./customPagination.vue?vue&type=script&lang=js"
import style0 from "./customPagination.vue?vue&type=style&index=0&id=b7bd3d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports